export const BASE_API = process.env.REACT_APP_BASE_API
export const DOCUMENTS_API = process.env.REACT_APP_DOCUMENTS_API
export const APPLICANTS_API = process.env.REACT_APP_APPLICANTS_API
export const TICKETING_APP = process.env.REACT_APP_TICKETING_APP
export const TICKETING_API = process.env.REACT_APP_TICKETING_API
export const DASHBOARD_APP = process.env.REACT_APP_DASHBOARD_APP
export const HAJKO_FEST_URL = process.env.REACT_APP_HAJKO_FEST_URL
export const ALLOWED_DASHBOARD_VIEWERS = process.env.REACT_APP_ALLOWED_DASHBOARD_VIEWERS
export const RESTRICTED_MANAGERS = process.env.REACT_APP_RESTRICTED_MANAGERS
export const PAYROLL_MANAGERS = process.env.REACT_APP_PAYROLL_MANAGERS

/** Microsoft Forms URLs for onboarding surveys (optional; falls back to API `formUrl`). */
export const ONBOARDING_SURVEY_30_FORM_URL = (
  process.env.REACT_APP_ONBOARDING_SURVEY_30_FORM_URL || ''
).trim()
export const ONBOARDING_SURVEY_60_FORM_URL = (
  process.env.REACT_APP_ONBOARDING_SURVEY_60_FORM_URL || ''
).trim()
